import './../Filter/Filter.scss';
import Component from './LenderListFilter.js';
export default Component;